import log from "cslog";
import React from "react";
// import Dropdown from "../../forms/elements/Dropdown";
import debounce from "lodash/debounce";
import { useEffect, useState } from "react";
import { usePageDbConfig } from "../../../../db";
import { mobile, parseStyle, tablet } from "../../../../juntion";

function QPagination({ id, db, device, gs, dydb, ctx }) {
    const data = db[id];
    const [page_dbc, setPageDBC] = usePageDbConfig(ctx.page_id);

    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const btn_style = {
        padding: "7px 14px",
        border: "1px solid #ccc",
        backgroundColor: "white",
        cursor: "pointer",
    };

    const active_style = {
        color: "white",
        backgroundColor: "royalblue",
    };

    const source = input.dataSource;
    const content = dydb[source];

    // log.d(content, "Content in QPagination");

    const total_count = content?.data?.meta?.filter_count || 0;
    const per_page = page_dbc[source]?.per_page || input.recordsPerPage;
    const num_pages = Math.ceil(total_count / per_page);
    const current_page_no = page_dbc[source]?.page_no || 1;

    // log.d(total_count, "Total count");
    // log.d(per_page, "Per page");

    const setPageNo = (page_no) => {
        setPageDBC({
            ...page_dbc,
            [source]: {
                ...(page_dbc[source] || {}),
                page_no: page_no,
                per_page: input.recordsPerPage,
            },
        });
    };

    useEffect(() => {
        if (page_dbc[source]?.["per_page"] != input.recordsPerPage) {
            setPageNo(1);
        }
    }, [input.recordsPerPage, page_dbc, source]);

    return (
        <div>
            {total_count > 0 && (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                    }}
                >
                    <button
                        style={btn_style}
                        onClick={() => setPageNo(current_page_no - 1)}
                        disabled={current_page_no <= 1}
                    >
                        {"<"}
                    </button>
                    {Array.from({ length: num_pages }).map((item, i) => {
                        return (
                            <div
                                key={i}
                                onClick={() => setPageNo(i + 1)}
                                style={{
                                    ...btn_style,
                                    ...(current_page_no === i + 1
                                        ? active_style
                                        : {}),
                                }}
                            >
                                {i + 1}
                            </div>
                        );
                    })}
                    <button
                        style={btn_style}
                        onClick={() => setPageNo(current_page_no + 1)}
                        disabled={current_page_no >= num_pages}
                    >
                        {">"}
                    </button>
                </div>
            )}
        </div>
    );
}

export default QPagination;
